module.exports = __webpack_public_path__ + "img/sample_cabinet3.7f3f06b4.png";